var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.90001H20.1C20.3387 3.90001 20.5676 3.99483 20.7364 4.16361C20.9052 4.33239 21 4.56131 21 4.80001V19.2C21 19.4387 20.9052 19.6676 20.7364 19.8364C20.5676 20.0052 20.3387 20.1 20.1 20.1H3.9C3.66131 20.1 3.43239 20.0052 3.2636 19.8364C3.09482 19.6676 3 19.4387 3 19.2V4.80001C3 4.56131 3.09482 4.33239 3.2636 4.16361C3.43239 3.99483 3.66131 3.90001 3.9 3.90001H7.5V2.10001H9.3V3.90001H14.7V2.10001H16.5V3.90001ZM14.7 5.70001H9.3V7.50001H7.5V5.70001H4.8V9.30001H19.2V5.70001H16.5V7.50001H14.7V5.70001ZM19.2 11.1H4.8V18.3H19.2V11.1Z",
    fill: "#525866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLine);
export default __webpack_public_path__ + "static/media/calendar-line.a519623428d09bff2ab5e201634c9e9c.svg";
export { ForwardRef as ReactComponent };